import { PageContainer, ProForm, ProFormText } from '@ant-design/pro-components';
import { App, Avatar, Card, Flex } from 'antd';
import { useMemo } from 'react';
import { useAppContext } from '@/common/hooks/AppStateProvider';
import { updateCurrentUser } from '../services/settings';

const Settings = () => {
  const { message } = App.useApp();
  const { session } = useAppContext();
  const { user } = session;
  const initialValues = useMemo(
    () => ({
      name: user?.name,
      phoneNumber: user?.phoneNumber,
    }),
    [user],
  );

  return (
    <PageContainer>
      <Card variant="borderless">
        <ProForm
          layout="vertical"
          initialValues={initialValues}
          submitter={{
            searchConfig: {
              submitText: '更新基本信息',
            },
            render: (_, dom) => dom[1],
          }}
          onFinish={async (values) => {
            await updateCurrentUser({
              name: values.name,
            });
            await session.refresh({ background: true });
            message.success('基本信息已更新');
            return true;
          }}
        >
          <Flex gap="large">
            <Flex vertical>
              <ProFormText width="md" name="phoneNumber" label="手机号" readonly />
              <ProFormText
                width="md"
                name="name"
                label="姓名"
                rules={[
                  {
                    required: true,
                    message: '请输入姓名',
                  },
                ]}
              />
            </Flex>
            <Avatar size={64} src={user?.image || user?.avatar}>
              {user?.name?.slice(0, 1)}
            </Avatar>
          </Flex>
        </ProForm>
      </Card>
    </PageContainer>
  );
};

export default Settings;
